// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"137e4315","531":"cb2f9f12","859":"633d8923"}[chunkId] + ".chunk.js";
};